import script from "./EventAttendanceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EventAttendanceDialog.vue?vue&type=script&setup=true&lang=js"

import "./EventAttendanceDialog.vue?vue&type=style&index=0&id=63ae8b2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ae8b2c"]])

export default __exports__